/**
 * Role-based navigation. Labels follow the student product spec.
 * Routes reuse existing pages. status: implemented | coming-soon
 */

export const STUDENT_NAV = [
    { name: 'Home', href: '/dashboard', status: 'implemented', shortcut: true },
    {
        name: 'Profile & Onboarding',
        href: '/profile',
        status: 'implemented',
        shortcut: true,
        children: [
            { name: 'Talent Profile', href: '/profile', status: 'implemented' }
        ]
    },
    {
        name: 'Learning & Hours',
        // Points at the first visible child while the two pages below are hidden.
        href: '/learning-modules',
        status: 'implemented',
        shortcut: true,
        children: [
            // Hidden from the sidebar for now; the pages and routes still exist.
            // { name: 'Practical Hours', href: '/hours', status: 'implemented' },
            // { name: 'Learning & Training', href: '/learning', status: 'implemented' },
            { name: 'Video Learning Modules', href: '/learning-modules', status: 'implemented' },
            { name: 'Tasks', href: '/tasks', status: 'implemented' },
            { name: 'Practical Challenges', href: '/practical-challenges', status: 'implemented' }
        ]
    },
    // Client and internship projects share one page (tabs at /business and /projects).
    { name: 'Projects', href: '/business', activePaths: ['/projects'], status: 'implemented' },
    {
        name: 'Help',
        href: '/help',
        status: 'implemented',
        children: [
            { name: 'AI Coach', href: '/ai-coach', status: 'implemented' },
            { name: 'Help & Support', href: '/help', status: 'implemented' }
        ]
    },
    { name: 'Professional Journey', href: '/professional-journey', status: 'implemented' },
    { name: 'Evidence', href: '/evidence', status: 'implemented' },
    { name: 'Achievements', href: '/completion', status: 'implemented' },
    { name: 'Notifications', href: '/notifications', status: 'implemented' }
];

export const MENTOR_NAV = [
    { name: 'Mentor Dashboard', href: '/mentor/dashboard', status: 'implemented' },
    { name: 'Assigned Interns', href: '/mentor/interns', status: 'implemented' },
    { name: 'Video Learning Modules', href: '/mentor/learning-modules', status: 'implemented' },
    { name: 'Intern Reviews', href: '/mentor/interns', status: 'implemented' },
    { name: 'Practical Challenges', href: '/mentor/practical-challenges', status: 'implemented' },
    { name: 'Challenge Reviews', href: '/mentor/challenge-reviews', status: 'implemented' },
    { name: 'Hour Approvals', href: '/mentor/dashboard', status: 'implemented' },
    { name: 'Mentor Feedback', href: '/mentor/interns', status: 'implemented' },
    { name: 'Projects', href: '/business', activePaths: ['/projects'], status: 'implemented' },
    { name: 'Notifications', href: '/notifications', status: 'implemented' }
];

export const ADMIN_NAV = [
    { section: 'OVERVIEW' },
    { name: 'Dashboard', href: '/admin/dashboard', status: 'implemented' },
    { name: 'Reports', href: '/admin/reports', status: 'implemented', permission: { resource: 'reports', action: 'read' } },
    { section: 'PEOPLE' },
    { name: 'Interns', href: '/admin/interns', status: 'implemented' },
    { name: 'Cohorts', href: '/admin/cohorts', status: 'implemented' },
    { name: 'Mentors & staff', href: '/admin/staff', status: 'implemented' },
    { name: 'Onboarding', href: '/admin/onboarding', status: 'implemented' },
    { name: 'User Info', href: '/admin/user-info', status: 'implemented' },
    { name: 'Career directions', href: '/admin/career-directions', status: 'implemented' },
    { section: 'DELIVERY' },
    { name: 'Learning & hours', href: '/admin/hours', status: 'implemented' },
    { name: 'Projects', href: '/business', activePaths: ['/projects'], status: 'implemented' },
    { name: 'Solutions', href: '/solutions', status: 'implemented' },
    { name: 'Pilots', href: '/pilots', status: 'implemented' },
    { name: 'Practical challenges', href: '/admin/practical-challenges', status: 'implemented' },
    { name: 'Challenge reviews', href: '/mentor/challenge-reviews', status: 'implemented' },
    { name: 'Review queue', href: '/admin/support', status: 'implemented' },
    { section: 'SETUP' },
    { name: 'Settings', href: '/admin/settings', status: 'implemented' },
    { name: 'Notifications', href: '/notifications', status: 'implemented' },
];

export const MENTOR_ADMIN_ROLES = ['mentor', 'admin'];
export const ADMIN_ONLY_ROLES = ['admin'];

export function getPrimaryNavRole(roles = []) {
    const names = (roles || []).map((role) => (typeof role === 'string' ? role : role.name)).filter(Boolean);
    if (names.includes('super_admin') || names.includes('program_manager')) return 'admin';
    if (names.includes('mentor')) return 'mentor';
    return 'intern';
}

export function getNavigationForRole(navRole) {
    if (navRole === 'admin') return ADMIN_NAV;
    if (navRole === 'mentor') return MENTOR_NAV;
    return STUDENT_NAV;
}

export function getHomePath(navRole) {
    if (navRole === 'admin') return '/admin/dashboard';
    if (navRole === 'mentor') return '/mentor/dashboard';
    return '/dashboard';
}
